// 🚨 Auto-generated file. Do not edit manually.

export const servImages = {
  madEliteCeramicCoating: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1742011879/mad-web-app/serv-images/mad-elite-ceramic-coating.webp',
    publicId: 'mad-web-app/serv-images/mad-elite-ceramic-coating',
    alt: 'Mad Elite Ceramic Coating Serv Image',
  },
  madSignatureMfCeramicCoating: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741884814/mad-web-app/serv-images/mad-signature-mf-ceramic-coating.webp',
    publicId: 'mad-web-app/serv-images/mad-signature-mf-ceramic-coating',
    alt: 'Mad Signature Mf Ceramic Coating Serv Image',
  },
  madClassicCeramicCoating: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741884086/mad-web-app/serv-images/mad-classic-ceramic-coating.jpg',
    publicId: 'mad-web-app/serv-images/mad-classic-ceramic-coating',
    alt: 'Mad Classic Ceramic Coating Serv Image',
  },
  madDeluxeFullDetail: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1741881865/mad-web-app/serv-images/mad-deluxe-full-detail-2.jpg',
    publicId: 'mad-web-app/serv-images/mad-deluxe-full-detail-2',
    alt: 'Mad Deluxe Full Detail Serv Image',
  },
  totalInteriorDetail: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1740550080/mad-web-app/serv-images/total-interior-detail.webp',
    publicId: 'mad-web-app/serv-images/total-interior-detail',
    alt: 'Total Interior Detail Serv Image',
  },
  fullInteriorDetail: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1740549852/mad-web-app/serv-images/full-interior-detail.jpg',
    publicId: 'mad-web-app/serv-images/full-interior-detail',
    alt: 'Full Interior Detail Serv Image',
  },
  exteriorClayPolish: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1740549480/mad-web-app/serv-images/exterior-clay-polish.jpg',
    publicId: 'mad-web-app/serv-images/exterior-clay-polish',
    alt: 'Exterior Clay Polish Serv Image',
  },
  exteriorDeconProtect: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1740549210/mad-web-app/serv-images/exterior-decon-protect.jpg',
    publicId: 'mad-web-app/serv-images/exterior-decon-protect',
    alt: 'Exterior Decon Protect Serv Image',
  },
  exteriorWashProtect: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1740548908/mad-web-app/serv-images/exterior-wash-protect.webp',
    publicId: 'mad-web-app/serv-images/exterior-wash-protect',
    alt: 'Exterior Wash Protect Serv Image',
  },
  madRefreshFullDetail: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1740531909/mad-web-app/serv-images/mad-refresh-full-detail.jpg',
    publicId: 'mad-web-app/serv-images/mad-refresh-full-detail',
    alt: 'Mad Refresh Full Detail Serv Image',
  },
  madExpressClean: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1740531909/mad-web-app/serv-images/mad-express-clean.jpg',
    publicId: 'mad-web-app/serv-images/mad-express-clean',
    alt: 'Mad Express Clean Serv Image',
  },
  fullWindowTint: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1739931043/mad-web-app/serv-images/full-window-tint.png',
    publicId: 'mad-web-app/serv-images/full-window-tint',
    alt: 'Full Window Tint Serv Image',
  },
  standardWindowTint: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1739931028/mad-web-app/serv-images/standard-window-tint.png',
    publicId: 'mad-web-app/serv-images/standard-window-tint',
    alt: 'Standard Window Tint Serv Image',
  },
  windshieldTint: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1739931015/mad-web-app/serv-images/windshield-tint.png',
    publicId: 'mad-web-app/serv-images/windshield-tint',
    alt: 'Windshield Tint Serv Image',
  },
  front2Windows: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1739931004/mad-web-app/serv-images/front-2-windows.png',
    publicId: 'mad-web-app/serv-images/front-2-windows',
    alt: 'Front 2 Windows Serv Image',
  },
  windshieldStrip: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1739930970/mad-web-app/serv-images/windshield-strip.png',
    publicId: 'mad-web-app/serv-images/windshield-strip',
    alt: 'Windshield Strip Serv Image',
  },
  windowTint: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1739417470/mad-web-app/serv-images/window-tint.webp',
    publicId: 'mad-web-app/serv-images/window-tint',
    alt: 'Window Tint Serv Image',
  },
  madSignatureCeramicCoating: {
    url: 'https://res.cloudinary.com/mayes-auto-detailing-llc/image/upload/q_auto,f_auto/v1739373593/mad-web-app/serv-images/mad-signature-ceramic-coating.webp',
    publicId: 'mad-web-app/serv-images/mad-signature-ceramic-coating',
    alt: 'Mad Signature Ceramic Coating Serv Image',
  },
};
